import { Product } from '~/Api/Product';
import FilterParameter from '~/utils/FilterParameter/FilterParameter';

import logGoogleTagManagerEvent from './logGoogleTagManagerEvent';

export default function logGoogleTagManagerGroupProductsAdd(
	groupId: string,
	products: Product[] | null,
	filterParameters: FilterParameter<string | string[]>[] | null
) {
	logGoogleTagManagerEvent({
		event: 'cogvio.groupProductsAdd',
		groupProductsAdd: {
			group: {
				id: groupId,
			},
			products: products
				? products.map((product) => ({
						id: product.id,
						brandName: product.brandName,
				  }))
				: null,
			filterParameters:
				filterParameters?.reduce((result: { [key: string]: string }, filterParameter) => {
					// @ts-expect-error filter paramters strange typing
					result[filterParameter.name] = filterParameter.value;
					return result;
				}, {}) || null,
		},
	});
}
